import React from 'react'
import { Box } from '@mui/material'
import FixedWidthContainer from 'components/FixedWidthContainer'
import LoginForm from 'pages/Login/LoginForm'
import DealerSignupSection from 'components/DealerSignupSection'
import SectionHeader from 'components/SectionHeader'
import { useTranslation } from 'react-i18next'

const LoginPage = () => {
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '80vh'
      }}
    >
      <FixedWidthContainer>
        <SectionHeader title={t('login.title')} />
        <LoginForm />
      </FixedWidthContainer>

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%'
        }}
      >
        <DealerSignupSection />
      </Box>
    </Box>
  )
}

export default LoginPage
